import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#9C0D76', // Your brand purple
      light: '#B82E91', // Lighter purple
      dark: '#7A0A5C', // Darker purple
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2D7DD2', // Complementary blue
      light: '#5098E3', // Lighter blue
      dark: '#1C5C9E', // Darker blue
      contrastText: '#ffffff',
    },
    heart: {
      main: '#f50057', // Keep existing heart color
      dark: '#E6325F',
    },
    success: {
      main: '#2E7D32', // Green for success states
      light: '#4CAF50',
      dark: '#1B5E20',
    },
    info: {
      main: '#0288D1', // Info blue
      light: '#03A9F4',
      dark: '#01579B',
    },
    warning: {
      main: '#ED6C02', // Warning orange
      light: '#FF9800',
      dark: '#C77700',
    },
    error: {
      main: '#D32F2F', // Error red
      light: '#EF5350',
      dark: '#C62828',
    },
    text: {
      primary: '#2C2C2C',
      secondary: '#666666',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
      light: '#F5F5F5',
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#E0E0E0',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: [
    'none',
    '0px 2px 4px rgba(0,0,0,0.1)',
    '0px 4px 8px rgba(0,0,0,0.12)',
    // ... rest of the shadows
  ],
});

export default theme;
